import { useContext } from 'react';
import { Card, CardHeader, CardContent, Avatar, Typography } from '@material-ui/core';
import { TabsContext } from './TabsContext';
import PersonIcon from '@material-ui/icons/PersonOutlined'
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme: any) => ({
    root: {   
        width: '100%',
        marginTop: 20  
    },
    user: {
        display: 'flex',
        alignItems: 'center',
    },
    avatar: {
        marginRight: theme.spacing(1)
    }
}));

export const OpenerSelector = (props): JSX.Element => {
    const classes = useStyles();

    const {
        values
    } = useContext(TabsContext);

    return (
        <Card className={classes.root}>
            <CardHeader title="AOF Opener" />
            <CardContent>
                <div className={classes.user}>
                    <Avatar aria-label="recipe" className={classes.avatar}>
                        <PersonIcon />
                    </Avatar>
                    <Typography>
                        {values.ownerFullName}
                    </Typography>
                </div>
            </CardContent>
        </Card>
    );
}